






import { HeatingSystemHealth as HeatingSystemHealthEnum } from '@/types/iot-portal';
import { BooleanProp, EnumProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { HeatingSystemHealthMeta, HEATING_SYSTEM_HEALTH_META } from './constants';

@Component
export default class HeatingSystemHealth extends Vue {
  @EnumProp(...Object.keys(HEATING_SYSTEM_HEALTH_META))
  private readonly health!: HeatingSystemHealthEnum;

  @BooleanProp()
  private readonly capitalize!: boolean;

  @BooleanProp()
  private readonly inline!: boolean;

  private get meta(): HeatingSystemHealthMeta {
    return HEATING_SYSTEM_HEALTH_META[this.health];
  }

  private get style(): Record<string, string | undefined> {
    return {
      display: this.inline ? 'inline' : undefined,
      'text-transform': this.capitalize ? 'capitalize' : undefined,
      color: this.meta.color,
    };
  }
}
